import {AfterViewInit, Component, Input, ViewChild} from '@angular/core';
import {Options} from 'sortablejs';
import {NotificationService} from 'src/app/common/services/notifications.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ProdutosService} from '../services/produtos.service';
import {AreasService} from '../services/areas.service';
import {DesenvolvedoresService} from '../services/desenvolvedores.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'store-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements AfterViewInit {

    @Input()
    produto: any;

    @ViewChild('modalConfirmarPublicacao')
    private modalConfirmarPublicacao: any;

    private plataformas: Array<any> = [
        {
            chave: 'WEB',
            valor: 'Cloud'
        },
        {
            chave: 'MOBILE',
            valor: 'Mobile'
        },
        {
            chave: 'EXTENSAO',
            valor: 'Extensão'
        }
    ];
    private areasNegocio: Array<any> = [];
    private desenvolvedores: Array<any> = [];

    isLoading: boolean;

    show: any = {
        header: false,
        highlights: false,
        powerNumbers: false,
        video: false,
        beneficios: false,
        maisInformacoes: false,
        cases: false,
        perguntasFrequentes: false
    };

    tagNames: any = {
        header: 'produto-header',
        highlights: 'highlights',
        powerNumbers: 'power-numbers',
        video: 'video-produto',
        beneficios: 'beneficios',
        maisInformacoes: 'mais-informacoes',
        cases: 'cases',
        perguntasFrequentes: 'perguntas'
    };

    sortableOptions: Options = {};

    private imageDestination: Array<any>;

    constructor(
        private productsService: ProdutosService,
        private areasService: AreasService,
        private desenvolvedoresService: DesenvolvedoresService,
        private notificationService: NotificationService,
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute
    ) {
    }

    ngAfterViewInit() {
        this.getAreasNegocio();
        this.initPlataformaSelect();
        this.getDesenvolvedores();
    }

    private initPlataformaSelect(): void {
        const listaPlataformas = [];
        const selectPlataforma: HTMLBthSelectElement = document.querySelector('bth-select[name=plataformaSelect]');
        this.plataformas.forEach(area => {
            listaPlataformas.push({
                id: area.chave,
                description: area.valor
            });
        });
        selectPlataforma.setOptions(listaPlataformas).then(() => {
            selectPlataforma.setOptionByValue(this.produto.plataforma.chave);
        });
    }

    private getAreasNegocio(): void {
        this.areasService.getAll().then(result => {
            this.areasNegocio = result;
            this.initAreaSelect();
        });
    }

    private initAreaSelect(): void {
        const listaAreas = [];
        const selectArea: HTMLBthSelectElement = document.querySelector('bth-select[name=areaSelect]');
        this.areasNegocio.forEach(area => {
            listaAreas.push({
                id: area.id,
                description: area.descricao
            });
        });
        selectArea.setOptions(listaAreas).then(() => {
            selectArea.setOptionByValue(this.produto.areaNegocio.identificador);
        });
    }

    private getDesenvolvedores(): void {
        this.desenvolvedoresService.getAll().then(result => {
            this.desenvolvedores = result;
            this.initDesenvolvedoresSelect();
        });
    }

    private initDesenvolvedoresSelect(): void {
        const listaDesenvolvedores = [];
        const selectDesenvolvedor: HTMLBthSelectElement = document.querySelector('bth-select[name=desenvolvedorSelect]');
        this.desenvolvedores.forEach(desenvolvedor => {
            listaDesenvolvedores.push({
                id: desenvolvedor.id,
                description: desenvolvedor.nome
            });
        });
        selectDesenvolvedor.setOptions(listaDesenvolvedores).then(() => {
            selectDesenvolvedor.setOptionByValue(this.produto.desenvolvedor.id);
        });
    }

    onChangeArea(event: any): void {
        const id: number = event.detail.value;
        this.produto.areaNegocio = this.areasNegocio.find(areaNegocio => areaNegocio.id === id.toString());
    }

    onChangePlataforma(event: any): void {
        const chave: string = event.detail.value;
        this.produto.plataforma = this.plataformas.find(plat => plat.chave === chave);
    }

    onChangeDesenvolvedor(event: any): void {
        const id: number = event.detail.value;
        this.produto.desenvolvedor = this.desenvolvedores.find(desenv => desenv.id === id.toString());
    }

    save(): void {
        this.produto.ehPublicado = false;
        this.productsService.setDraft(this.produto).then(() => {
            this.notificationService.publish({type: 'success', description: 'Rascunho salvo com sucesso'});
        });
    }

    publish(): void {
        this.modalService.open(this.modalConfirmarPublicacao, {backdrop: 'static'});
    }

    confirmPublish(): void {
        this.isLoading = true;
        this.modalService.dismissAll();

        if (this.produto.ehPublicado) {
            this.productsService.update(this.produto).then(() => {
                this.emitPublishFeedback();
            }).catch((reason: any) => {
                this.isLoading = false;
                this.notificationService.publish({
                    type: 'danger',
                    description: reason?.error?.detail?.message || reason?.error?.message ||
                        'Falha ao salvar, verifique os dados inseridos e tente novamente'
                });
            })
        } else {
            this.productsService.getProduct(this.produto.idLoja).then(result => {
                if (result && result.idLoja === this.produto.idLoja) {
                    this.updateByDraft();
                } else {
                    this.publishDraft();
                }
            }).catch(() => {
                this.publishDraft();
            });
        }
    }

    private updateByDraft(): void {
        this.productsService.deleteDraft(this.produto);
        this.productsService.update(this.produto).then(() => {
            this.emitPublishFeedback();
        });
    }

    private publishDraft(): void {
        const idDraftLoja = this.produto.idLoja;

        delete this.produto.idLoja;

        this.productsService.add(this.produto).then(() => {
            this.productsService.deleteDraft({...this.produto, idLoja: idDraftLoja});
            this.emitPublishFeedback();
        }).catch((reason: any) => {
            console.error(reason);
            this.produto.idLoja = idDraftLoja;

            this.notificationService.publish({
                type: 'danger',
                description: reason?.error?.detail?.message || reason?.error?.message ||
                    'Falha ao salvar, verifique os dados inseridos e tente novamente'
            });
        }).finally(() => {
            this.isLoading = false;
        });
    }

    private emitPublishFeedback(): void {
        this.notificationService.publish({type: 'success', description: 'Publicação realizada com sucesso'});
        setTimeout(() => {
            this.isLoading = false;
            this.router.navigate(['./admin']);
        }, 1000);
    }

    toggleVisibility(item: string): void {
        this.show[item] = !this.show[item];
        if (this.show[item]) {
            this.scrollTo(item);
        }
    }

    toggleSection(property: string, item: string): void {
        this.produto[property] = !this.produto[property];
        if (this.produto[property]) {
            this.show[item] = true;
            setTimeout(() => {
                this.scrollTo(item);
            }, 250);
        }
    }

    private scrollTo(item): void {
        const element: any = document.getElementsByTagName(`store-${this.tagNames[item]}`)[0];
        const wrapper: any = document.getElementById('productWrapper');
        if (element && wrapper) {
            let top = 0;
            if (item !== 'header') {
                top = element.offsetTop - 120;
            }
            wrapper.scrollTo({
                top,
                behavior: 'smooth'
            });
        }
    }

    removeItem(list: string, index: number): void {
        this.produto[list].splice(index, 1);
    }

    addHighlight(): void {
        const id: number = this.produto.highlights.length + 1;
        this.produto.highlights.push({
            id,
            icone: '',
            titulo: '',
            subtitulo: ''
        });
    }

    addPowerNumber(): void {
        const id: number = this.produto.powerNumbers.length + 1;
        this.produto.powerNumbers.push({
            id,
            icone: '',
            numero: '',
            descricao: ''
        });
    }

    addBeneficio(): void {
        const id: number = this.produto.beneficios.length + 1;
        this.produto.beneficios.push({
            id,
            titulo: '',
            subtitulo: ''
        });
    }

    addInformacao(): void {
        const id: number = this.produto.maisInformacoes.length + 1;
        this.produto.maisInformacoes.push({
            id,
            titulo: '',
            imagem: '',
            descricao: ''
        });
    }

    addCase(): void {
        const id: number = this.produto.cases.length + 1;
        this.produto.cases.push({
            id,
            titulo: '',
            imagem: '',
            descricao: '',
            endereco: ''
        });
    }

    addDepoimento(): void {
        const id: number = this.produto.depoimentos.length + 1;
        this.produto.depoimentos.push({
            id,
            imagem: '',
            nome: '',
            profissao: '',
            comentario: ''
        });
    }

    addPergunta(): void {
        const id: number = this.produto.perguntasFrequentes.length + 1;
        this.produto.perguntasFrequentes.push({
            id,
            pergunta: '',
            resposta: ''
        });
    }

    selectImageToUpload(destination: Array<any>): void {
        this.imageDestination = destination;
        const uploader: any = document.getElementById('fileUploader');
        uploader.click();
    }

    handleFileInput(files: FileList) {
        const file: File = files.item(0);
        const formData = new FormData();
        formData.append('file', file, file.name);
        this.isLoading = true;
        const uploader: any = document.getElementById('fileUploader');
        uploader.value = null;
        this.productsService.updloadImage(formData).then(result => {
            const imageUrl = result.url;
            if (this.imageDestination.length === 1) {
                this.produto[this.imageDestination[0]] = imageUrl;
            } else if (this.imageDestination.length === 3) {
                this.produto[this.imageDestination[0]][this.imageDestination[1]][this.imageDestination[2]] = imageUrl;
            }
            this.isLoading = false;
        });
    }

    slugify(text) {
        return text
            .toString()
            .toLowerCase()
            .normalize('NFD')
            .trim()
            .replace(/\s+/g, '-')           // Substitua os espaços por -
            .replace(/[^\w\-]+/g, '')       // Remova todos os caracteres não string
            .replace(/\-\-+/g, '-');        // Substitua vários - por um -
    }

}
